module.exports = __webpack_public_path__ + "static/media/iconDownloadLastStepHorizontal.a7f7c5a3.svg";